export default {
  issuingDetail: {
    collapseTitle: {
      baseTitle: '开证申请',
      contractDetail: '合同信息',
      fileTitle: '附件上传',
      issuingInfo: '开证信息',
      accountingDoc: '会计凭证',
    },
    btnList: {
      edit: '修改',
      save: '保存',
      submit: '完成开证',
      cancel: '撤销开证',
      upload: '上传附件',
      print: '生成凭证',
      add: '新增',
      remove: '删除',
      copy: '复制',
      ladeOrder: '提单',
      viewLadeOrder: '查看提单',
    },
    baseForm: {
      clCode: '信用证号',
      clCodePlaceholder: '请填写信用证号',
      issueDate: '开证日期',
      issueDatePlaceholder: '请选择开证日期',
      applyBranchName: '开证银行',
      applyBranchNamePlaceholder: '请填写开证银行卡号',
      issueType: '开证类型',
      marginRate: '银行保证金比率/%',
      marginAmount: '银行保证金金额',
      marginAmountPlaceholder: '请填写银行保证金金额',
      marginCurrencyCode: '保证金币别编码',
      marginCurrencyName: '保证金币别',
      marginCurrencyNamePlaceholder: '请选择保证金币别',
      marginPayDate: '保证金支付日期',
      marginExchangeRateDate: '汇率日期',
      marginExchangeRate: '汇率',
      marginStandardAmount: '银行保证金本币金额',
      marginPayAccount: '保证金付款银行账户',
      cashflowTransactionCode: '现金流量代码',
      isIndependent: '独立开证',
      isForeignParent: '外商母证开证',
      isRefundMargin: '已退回保证金',
    },
    goodsTable: {
      indexTitle: '序号',
      contractNo: '合同号',
      externalContractNo: '外部合同号',
      contractDetailNo: '合同行项目',
      productNo: '物料号',
      productDesc: '物料描述',
      purchaseQuantity: '数量',
      issueQuantity: '实际数量',
      businessContractUnitPrice: '单价',
      businessContractTotalAmount: '总金额',
      issueAmount: '本次开证金额',
    },
    msg: {
      detailTip: '请填写必要的开证申请信息',
      updateSusscess: '修改成功！',
      saveSussess: '新增成功！',
      submitSussess: '完成开证成功！',
      cancelSussess: '撤销开证成功！',
      revokeSussess: '撤回成功！',
      success: '成功！',
      error: '失败！',
      comfirmSusscess: '确认成功！',
      confirmCancel: '是否确认撤销开证？',
      confirmRevoke: '是否确认撤回？',
    },
  },
};
